export interface FormatNumberOptions extends Intl.NumberFormatOptions {
    prefix?: string;
    suffix?: string;
    joinSeparator?: string;
}

export const formatNumber = (value: number, options?: FormatNumberOptions) =>
    [
        options?.prefix ? options.prefix : "",
        value.toLocaleString("en-US", { ...options, useGrouping: true }),
        options?.suffix ? options.suffix : "",
    ].join(options?.joinSeparator ?? "");

export const formatAddress = (address: string, leadingChars: number = 6, trailingChars: number = 4): string =>
    address.length < leadingChars + trailingChars
        ? address
        : `${address.substring(0, leadingChars)}\u2026${address.substring(address.length - trailingChars)}`;

export const formatDate = (date: Date) => `${date.getDate()} ${date.toLocaleString("en-US", { month: "short" })}`;

export const formatDateTime = (date: Date) =>
    `${date.getDate()} ${date.toLocaleString("en-US", { month: "short" })} at ${date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    })}`;

export const parseNumberString = (numStr: string): number => {
    const cleanedStr = numStr.replace(/[,']/g, '');
    const parsedNumber = parseFloat(cleanedStr);
    if (isNaN(parsedNumber)) {
        return 0;
    }
    return parsedNumber;
};

export const formatTvlNumber = (number: number) => {
    const absNumber = Math.abs(number);
    if (absNumber >= 1e6) {
        return (number / 1e6).toFixed(0).replace(/\.00$/, '') + 'M';
    } else if (absNumber >= 1e3) {
        return (number / 1e3).toFixed(0).replace(/\.00$/, '') + 'K';
    } else {
        return number.toFixed(2);
    }
};

export const formatSmartFixed6 = (value: number): string => {
    if (!isFinite(value)) return String(value);
    // Use toPrecision for very small numbers, but default to toFixed(6)
    let str = value.toFixed(6);
    // Remove trailing zeros after decimal and possible trailing decimal point
    str = str.replace(/(\.\d*?[1-9])0+$/g, '$1').replace(/\.0+$/, '').replace(/\.?$/, '');
    return str;
};

